export default __webpack_public_path__ + "static/media/sporange-Header-Logo.e6c39dbc.png";